import { getData, postData } from './http';

// It is important that this service matches mobile/localStorageProvider and desktop/localStorageProvider.
// They all need similar interfaces and similar behavour:
// When saving, they should merge the new values into the old ones, NOT splat them.
// This is important so that preferences can behave consistantly, for SignedIn and SignedOut users.
const preferenceServiceUrl = '/api2/useraccounts/preferences';

//string test functions
function isBool(val) {
    return /^(true|false)$/.test(val);
}

function isNull(val) {
    return val === 'null';
}

function isInt(val) {
    return /^\d+$/.test(val);
}

function isFloat(val) {
    return /^[0-9]*[.][0-9]+$/.test(val);
}

function isUndef(val) {
    return val === 'undefined';
}
//end string test functions

function parseObjectValues(data) {
    for (const i in data) {
        let val = data[i];

        try {
            val = JSON.parse(val);
        } catch (e) {
            if (isBool(val)) {
                val = val === 'true';
            } else if (isNull(val)) {
                val = null;
            } else if (isUndef(val)) {
                val = undefined;
            } else if (isInt(val)) {
                val = parseInt(val);
            } else if (isFloat(val)) {
                val = parseFloat(val);
            }
        }

        data[i] = val;
    }

    return data;
}

export function get(user, cb) {
    if (!user || !user.SignedIn || user.ImpersonatedSignedIn) {
        cb();
        return;
    }

    getData(`${preferenceServiceUrl}/get`, { logErrors: false })
        .then(function(data) {
            if (Object.keys(data).length) {
                cb(parseObjectValues(data));
            } else {
                cb();
            }
        })
        .catch(() => cb());
}

export function set(user, cb, prefs) {
    if (!user || !user.SignedIn) {
        cb();
        return;
    }

    const preferences = {};

    angular.forEach(prefs, function(val, key) {
        if (typeof val !== 'undefined' && val !== '[object Object]') {
            if (typeof val === 'string') {
                preferences[key] = val;
            } else {
                const json = angular.toJson(val);
                if (json.length < 2000) {
                    preferences[key] = json;
                }
            }
        }
    });

    const url = `${preferenceServiceUrl}/set`;
    const httpBody = { Preferences: preferences };

    postData(url, httpBody, { logErrors: false })
        .then(() => cb())
        .catch(() => cb());
}

export function remove(user, cb, key) {
    if (!user || !user.SignedIn) {
        cb();
        return;
    }

    const url = `${preferenceServiceUrl}/remove`;
    const httpBody = { PreferenceName: key };

    postData(url, httpBody, { logErrors: false })
        .then(() => cb())
        .catch(() => cb());
}
